import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

const flexCenter = `
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

export const Info = styled.div`
    ${flexCenter}
    padding: 0 1.4rem 1.4rem 1.4rem;
    gap: 1rem;
`
export const ContainerProductName = styled.div`
    ${flexCenter}
`

export const Form = styled.form`
    ${flexCenter}
    padding: 1.4rem 0;
    flex-grow: 1;
    width: 100%;
    justify-content: flex-end;
`

export const ContainerButton = styled.div`
    ${flexCenter}
    padding: 0 1.4rem 0 1.4rem;
    gap: .6rem;
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`
